<app-edit-layer-template
    [isFormValid]="!!formGroup()?.dirty && !!formGroup()?.valid"
    (goToPreviousPage)="closeDetail(layerBloc.value()!.id)"
    (submit)="submit()">
    @if (!formGroup()) {
        <app-loading />
    } @else {
        <form
            #formDiv
            [formGroup]="formGroup()!">
            <div
                class="grid py-4"
                [class]="isWide() ? 'grid-cols-3' : 'grid-cols-2'">
                <div class="form-field">
                    <label class="form-control-label">{{ 'layerName' | transloco }}</label>
                    <mat-form-field
                        appearance="outline"
                        class="text-sm w-full">
                        <input
                            formControlName="name"
                            matInput
                            type="text" />
                        @for (error of formGroup()!.controls.name.errors | keyvalue; track error) {
                            <mat-error class="error-field">{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                @if (layerBloc.value()!.hasGeom) {
                    <div class="form-field">
                        <label class="form-control-label">{{ 'order' | transloco }}</label>
                        <mat-form-field
                            appearance="outline"
                            class="text-sm">
                            <input
                                formControlName="order"
                                matInput
                                max="99"
                                min="0"
                                step="1"
                                type="number" />
                            @for (error of formGroup()!.controls.order.errors | keyvalue; track error) {
                                <mat-error class="error-field">{{ formService.getErrorMessage(error) }}</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="form-field">
                        <label class="form-control-label">{{ 'visibility' | transloco }}</label>
                        <app-slide-toggle-form-control
                            class="pt-2"
                            formControlName="isVisible"
                            (change)="updateVisibility()" />
                    </div>
                }
            </div>
            <div>
                <span class="font-normal text-lg pl-4">{{ 'attribute' | transloco: { COUNT: 2 } }}</span>
                <div
                    class="grid"
                    [class]="isWide() ? 'grid-cols-4' : 'grid-cols-2'">
                    @if (dataAttributes() !== null) {
                        <ng-container formArrayName="bookmarkedColumns">
                            @for (attribute of bookmarkedColumnsControl.controls; track attribute) {
                                <ng-container [formGroupName]="$index">
                                    <div
                                        class="flex flex-col"
                                        [class]="attribute.getRawValue().isBookmarked ? 'p-2' : 'p-4'">
                                        <app-edit-layer-bookmarked-attributes
                                            formControlName="order"
                                            ngDefaultControl
                                            [class.bookmarked]="attribute.getRawValue().isBookmarked"
                                            [column]="attribute.getRawValue().column"
                                            [hasError]="errorsIndexes().includes($index)"
                                            [isBookmarked]="attribute.getRawValue().isBookmarked"
                                            [order]="attribute.getRawValue().order"
                                            (changeOrder)="updateBookmarkedColumnsOrder($event, $index)"
                                            (toggleIsBookmarked)="updateBookmarkedColumns($index)" />
                                        <div class="flex flex-col text-xs font-semibold min-h-5">
                                            @if (
                                                formGroup()!.controls.bookmarkedColumns!.hasError('duplicates') &&
                                                formGroup()!
                                                    .controls.bookmarkedColumns!.getError('duplicates')
                                                    .includes($index)
                                            ) {
                                                <mat-error class="error-field">
                                                    {{ 'errorAttributeDuplicate' | transloco }}
                                                </mat-error>
                                            }
                                            @if (
                                                formGroup()!.controls.bookmarkedColumns!.hasError(
                                                    'outOfRangeIndexes'
                                                ) &&
                                                formGroup()!
                                                    .controls.bookmarkedColumns!.getError('outOfRangeIndexes')
                                                    .includes($index)
                                            ) {
                                                <mat-error class="error-field">
                                                    {{ 'errorOutOfRange' | transloco: { MIN: 1, MAX: 10 } }}
                                                </mat-error>
                                            }
                                            @if (
                                                formGroup()!.controls.bookmarkedColumns!.hasError(
                                                    'emptyOrderIndexes'
                                                ) &&
                                                formGroup()!
                                                    .controls.bookmarkedColumns!.getError('emptyOrderIndexes')
                                                    .includes($index)
                                            ) {
                                                <mat-error class="error-field">
                                                    {{ 'errorEmptyBookmarkedOrder' | transloco }}
                                                </mat-error>
                                            }
                                        </div>
                                    </div>
                                </ng-container>
                            }
                        </ng-container>
                    }
                </div>
            </div>
        </form>
    }
</app-edit-layer-template>
